import { useState } from "react";
import { useAuth } from "../../../context/contextAuth";
import { getUrlResults } from "../../../api/get/oci/get-url";
import { scanOciUrl } from "../../../api/post/post-oci";

const useOciUrl = () => {
  const { user, userId } = useAuth();
  const [url, setUrl] = useState("");
  const [webResults, setWebResults] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [urlScanLoading, setUrlScanLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchWebResults = async (requestedUserId = userId) => {
    const results = await getUrlResults(requestedUserId);
    setWebResults(Array.isArray(results) ? results : []);
    return Array.isArray(results) ? results : [];
  };

  const initData = async () => {
    if (!user || !userId) return [];
    try {
      return await fetchWebResults(userId);
    } catch (fetchError) {
      console.error("Error loading OCI web results:", fetchError);
      setWebResults([]);
      return [];
    }
  };

  const handleSubmit = async (event) => {
    event?.preventDefault?.();
    setUrlScanLoading(true);
    setError(null);
    try {
      await scanOciUrl(userId, url);
      const results = await fetchWebResults(userId);
      setCurrentIndex(Math.max(0, results.length - 1));
    } catch (scanError) {
      setError(scanError);
      throw scanError;
    } finally {
      setUrlScanLoading(false);
      setUrl("");
    }
  };

  const resetState = () => {
    setUrl("");
    setWebResults([]);
    setCurrentIndex(0);
    setUrlScanLoading(false);
    setError(null);
  };

  return {
    url,
    setUrl,
    webResults,
    currentIndex,
    setCurrentIndex,
    urlScanLoading,
    error,
    initData,
    fetchWebResults,
    handleSubmit,
    resetState,
  };
};

export default useOciUrl;

